import { FC, memo } from 'react'
import { Icon, Menu, MenuItem, Popover } from '@blueprintjs/core'
import { usePdfEditor, ValidationError } from './PdfEditorProvider'
import useCallbackDebounced from '../../../hooks/shared/useCallbackDebounced'
import Box from '@mui/material/Box'
import CircularProgress from '../CircularProgress'

const ValidationErrorRow: FC<{ validationError: ValidationError }> = ({ validationError }) => {
  const { store, validating } = usePdfEditor()
  const handleValidationErrorClicked = useCallbackDebounced(() => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    store.selectElements([validationError.element.id])
  }, [store, validationError])
  return (
    <MenuItem
      icon={
        validationError.element.type === 'text'
          ? 'font'
          : validationError.element.type === 'image' || validationError.element.type === 'svg'
            ? 'media'
            : 'selection-box'
      }
      text={`${validationError.message}`}
      disabled={validating}
      onClick={handleValidationErrorClicked}
    />
  )
}
const ValidationErrorsTracker: FC = () => {
  const { validationErrors, validating } = usePdfEditor()
  return (
    <Popover
      content={
        !validationErrors.length ? undefined : (
          <Menu>
            {validationErrors.map(validationError => (
              <ValidationErrorRow
                key={(validationError.element.id as string) + validationError.message}
                validationError={validationError}
              />
            ))}
          </Menu>
        )
      }
    >
      <Box
        sx={{
          position: 'relative',
        }}
      >
        {validationErrors.length === 0 ? (
          <Box
            component={'button'}
            disabled
            sx={{
              paddingLeft: 1,
              paddingRight: 1,
              paddingTop: 0,
              paddingBottom: 0,
              cursor: 'default',
              border: 'none',
              backgroundColor: 'transparent',
              [':focus']: {
                outline: 'none',
              },
            }}
          >
            <Icon icon={'tick-circle'} intent="success" />
          </Box>
        ) : (
          <Box
            component={'button'}
            sx={{
              paddingLeft: 1,
              paddingRight: 1,
              paddingTop: 0,
              paddingBottom: 0,
              cursor: 'pointer',
              border: 'none',
              backgroundColor: 'transparent',
              [':focus']: {
                outline: 'none',
              },
            }}
          >
            <Icon icon={'error'} intent="danger" />
          </Box>
        )}
        {validating && (
          <CircularProgress
            sx={{
              position: 'absolute',
              top: '-3px',
              left: '1px',
              color: validationErrors.length ? '#ad2f33' : '#1c6e42',
            }}
            size={30}
            thickness={5}
            color="error"
            delay={200}
          />
        )}
      </Box>
    </Popover>
  )
}

export default memo(ValidationErrorsTracker)
